// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"5c9d0050","297":"f50cafe6","643":"8ad5a66f"}[chunkId] + ".js";
};